import React, { useEffect } from 'react';
import Modal from '@mui/material/Modal';
import "./saleReturnRejectReasonModal.css"
import { TextField } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
const SaleReturnRejectReasonModal = (props: { open: boolean, closeModal: ()=>void, onClick:(reason:string)=>void }) => {
    const [reason, setReason] = React.useState<string>("");

    useEffect(() => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if ((event.ctrlKey || event.metaKey) && event.key === 'a') {
      event.preventDefault();
      const activeElement = document.activeElement;
      if (
        activeElement?.tagName !== 'INPUT' &&
        activeElement?.tagName !== 'TEXTAREA' &&
        reason !== ''
      ) {
        console.log('Ctrl+A/⌘+A triggered', { reason });
        props.onClick(reason);
      } else {
        console.log('Keyboard shortcut blocked', {
          reason,
          activeElement: activeElement?.tagName,
        });
      }
    }
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
}, [reason, props.onClick]);

    return (
        <Modal
            open={props.open}
            onClose={props.closeModal}
            aria-labelledby="sale-return-reject-reaosn-modal-title"
            aria-describedby="sale-return-reject-reaosn-modal-description"
        >
            <div className='sale-return-reject-reason-container'>
                <div className='sale-return-reject-reason-header'>
                    <FontAwesomeIcon
                        icon={faXmark}
                        onClick={props.closeModal}
                    />
                </div>
                <div className='sale-return-reject-reason-body'>
                    <div></div>
                    <div className='sale-return-reject-reason-title'>
                        Return is being rejected.
                    </div>
                    <div className='sale-return-reject-reason-input-container'>
                        <TextField
                            id="outlined-multiline-static"
                            label=""
                            multiline
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            rows={4}
                            fullWidth
                            placeholder="Please mention a reason for rejection..."
                            inputProps={{
                                maxLength: 250
                            }}
                            className='sale-return-reject-reason-input'
                        />
                        <div className='sale-return-reject-reason-character-limit'>
                            Maximum 250 characters
                        </div>
                    </div>
                    <button
                            className={`view-sale-return-submit ${reason ? "" : "disabled"}`}
                            onClick={()=>{props.onClick(reason)}}
                        >
                            <span className="view-sale-return-submit-text">
                                Continue
                            </span>
                        </button>
                </div>
            </div>
        </Modal>
    );
};

export default SaleReturnRejectReasonModal;
